import React from "react"
import game from "perudo.png"

const Perudo = props => <img src={game} className="game" {...props} />

export default Perudo
